import { animate, style, transition, trigger } from "@angular/animations";
import { Component, OnInit } from "@angular/core";
// @ts-ignore
import rolly from "rolly.js";
import Lenis from "@studio-freight/lenis";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  animations: [
    trigger("fade-on-if", [
      transition("void => active", [
        style({ opacity: 0 }),
        animate(250, style({ opacity: 1 })),
      ]),
      transition("* => void", [animate(250, style({ opacity: 0 }))]),
    ]),
  ],
})
export class HomeComponent implements OnInit {
  constructor() {}
  showSplash = true;

  ngOnInit(): void {
    setTimeout(() => {
      this.showSplash = false;
    }, 4300);
    // const r = rolly({
    //   view: document.querySelector('#app-main'),
    //   native: true,
    //   // other options
    // });
    // r.init();

    const lenis = new Lenis();

    function raf(time: any) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  }
}
